export default __webpack_public_path__ + "static/media/icon-power-plug.0dacddd4.svg";